"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _IllegalArgumentException = _interopRequireDefault(require("../../../../java/lang/IllegalArgumentException"));

var _Character = _interopRequireDefault(require("../../../../java/lang/Character"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Dimension =
/*#__PURE__*/
function () {
  function Dimension() {
    _classCallCheck(this, Dimension);

    Dimension.constructor_.apply(this, arguments);
  }

  _createClass(Dimension, [{
    key: "getClass",
    value: function getClass() {
      return Dimension;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "toDimensionSymbol",
    value: function toDimensionSymbol(dimensionValue) {
      switch (dimensionValue) {
        case Dimension.FALSE:
          return Dimension.SYM_FALSE;

        case Dimension.TRUE:
          return Dimension.SYM_TRUE;

        case Dimension.DONTCARE:
          return Dimension.SYM_DONTCARE;

        case Dimension.P:
          return Dimension.SYM_P;

        case Dimension.L:
          return Dimension.SYM_L;

        case Dimension.A:
          return Dimension.SYM_A;
      }

      throw new _IllegalArgumentException.default("Unknown dimension value: " + dimensionValue);
    }
  }, {
    key: "toDimensionValue",
    value: function toDimensionValue(dimensionSymbol) {
      switch (_Character.default.toUpperCase(dimensionSymbol)) {
        case Dimension.SYM_FALSE:
          return Dimension.FALSE;

        case Dimension.SYM_TRUE:
          return Dimension.TRUE;

        case Dimension.SYM_DONTCARE:
          return Dimension.DONTCARE;

        case Dimension.SYM_P:
          return Dimension.P;

        case Dimension.SYM_L:
          return Dimension.L;

        case Dimension.SYM_A:
          return Dimension.A;
      }

      throw new _IllegalArgumentException.default("Unknown dimension symbol: " + dimensionSymbol);
    }
  }]);

  return Dimension;
}();

exports.default = Dimension;

Dimension.constructor_ = function () {};

Dimension.P = 0;
Dimension.L = 1;
Dimension.A = 2;
Dimension.FALSE = -1;
Dimension.TRUE = -2;
Dimension.DONTCARE = -3;
Dimension.SYM_FALSE = 'F';
Dimension.SYM_TRUE = 'T';
Dimension.SYM_DONTCARE = '*';
Dimension.SYM_P = '0';
Dimension.SYM_L = '1';
Dimension.SYM_A = '2';